class L.GeomUndoStack extends L.Class

    constructor: (features) ->
        GeomUndoStack.include(L.Mixin.Events)

        @elements = []

        @featuregroup = features


    # Reverts the feature group to a previous state. This doesn't actually
    # "undo" a single operation, but rather wipes out the feature group's contents
    # and replaces them the contents of the feature group at the prior state
    #
    # This means that the geometries in the feature group are not modified versions
    # of themselves, but completely new geometries that may occupy the same locations
    # and have the same properties as they did previously
    undo: () ->
        prev = @pop()

        if not prev
            return false

        @featuregroup.clearLayers()

        if prev?.eachLayer
            prev.eachLayer (l) =>
                @featuregroup.addLayer l

            @fire 'undo'


    # Remove and return the last item in the stack
    pop: () ->
        if @elements.length is 0
            return false

        return @elements.pop()


    # Push the featuregroup's state onto the undo stack
    push: () =>
        if @featuregroup?.cloneGeom?
            state = @featuregroup.cloneGeom()
            state.isInvalid = @featuregroup.isInvalid

            @elements.push state
            @fire 'push'


    # Return the last item in the stack
    peek: () ->
        if @elements.length is 0
            return false

        return List.last(@elements)


    getAt: (i) ->

        if i < 0
            return @getAt(@elements.length + i)

        else
            if @elements[i]?
                return @elements[i]
            else
                return false


    clearInvalidGeometryFromStack: () ->
        # Remove any invalid states so once we have cleared the stack,
        # we can't undo *ever* to an invalid state
        @elements = List.filter (i) ->
            return not (i.isInvalid? and i.isInvalid)
        , @elements

        # If the current feature group is invalid, then undo
        # to the last known good state
        if @featuregroup.isInvalid? and @featuregroup.isInvalid
            @undo()

        @featuregroup.isInvalid = false
